import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2527a434"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timer" }
const _hoisted_2 = { class: "timer__actions" }

import { computed, watch, ref, onBeforeUnmount } from 'vue';

import TimerDisplay from './TimerDisplay.vue';
import DSButton from '@/design-system/DSButton.vue';

import { useStore } from '@/store';

interface Props {
  taskName: string;
  playRequestPending: boolean;
  stopRequestPending: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Timer',
  props: {
    taskName: { default: '' },
    playRequestPending: { type: Boolean, default: false },
    stopRequestPending: { type: Boolean, default: false }
  },
  emits: ['timeIsFinished', 'startTimer'],
  setup(__props: any, { emit }) {

const props = __props;





const store = useStore();
const timer = ref(0);
const timeInSeconds = ref(0);

const active_task = computed(() => store.state.task.active_task);

const timeIsRunning = computed(() => !! timer.value);

const stopTimer = (): void => {
  emit('timeIsFinished', timeInSeconds.value);
  handleTimeIsFinished();
};

const createTask = () => {
  emit('startTimer');
};

const handleTimeIsFinished = () => {
  clearInterval(timer.value);
  timer.value = 0;
  timeInSeconds.value = 0;
  document.title = 'Daily Constancy';
};

const startTimer = () => {
  timer.value = setInterval(() => {
    timeInSeconds.value = timeInSeconds.value + 1;
    const display_timer = new Date(timeInSeconds.value * 1000).toISOString().substring(11, 19);

    document.title = `${display_timer} - ${props.taskName}`;
  }, 1000);
};

onBeforeUnmount(() => {
  if (timer.value) {
    handleTimeIsFinished();
  }
});

watch(active_task, (state, prev_state) => {
  if (state.id && state.id !== prev_state.id) {
    clearInterval(timer.value);
    timeInSeconds.value = (active_task.value.total_time_spent || active_task.value.time_spent || 0);
    startTimer();
  }

  if (! state.id) {
    handleTimeIsFinished();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TimerDisplay, { "time-in-seconds": timeInSeconds.value }, null, 8, ["time-in-seconds"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DSButton, {
        loading: _ctx.playRequestPending,
        disabled: timeIsRunning.value,
        icon: "play_arrow",
        label: _ctx.$q.screen.gt.sm ? 'Start' : undefined,
        variant: "success",
        onClick: createTask,
        "aria-label": "Start timer"
      }, null, 8, ["loading", "disabled", "label"]),
      _createVNode(DSButton, {
        loading: _ctx.stopRequestPending,
        disabled: ! timeIsRunning.value,
        icon: "stop",
        label: _ctx.$q.screen.gt.sm ? 'Stop' : undefined,
        variant: "danger",
        onClick: stopTimer,
        "aria-label": "Stop timer"
      }, null, 8, ["loading", "disabled", "label"])
    ])
  ]))
}
}

})